import classNames from "classnames";
import Button from "../../../../ui/Button/Button";
import Card from "../../../../ui/Card/Card";
import { useDisclosure } from "../../../../ui/util/useDisclosure";
import styles from "./CreditsCard.module.scss";
import PurchaseCreditsModal from "./PurchaseCreditsModal/PurchaseCreditsModal";
import useUser from "../../../../providers/UserProvider/useUser";
import Tooltip from "../../../../ui/Tooltip/Tooltip";

function CreditsCard() {
  const { billingInfo, tenant } = useUser();
  const [purchaseCreditsModalOpened, purchaseCreditsModal] = useDisclosure();

  return (
    <Card className={styles.card}>
      <div className={classNames(styles.innerCard)}>
        <div className={styles.body}>
          <p className={styles.title}>Extra credits</p>
          <p className={styles.description}>
            Pay as you go, article credits never expire.
          </p>
          <p className={styles.credits}>
            <span className={styles.creditsNumber}>{billingInfo.credits}</span>
            {billingInfo.credits === 1 ? "credit" : "credits"}
          </p>
        </div>
        <div className={styles.footer}>
          {tenant?.parentTenant ? (
            <Tooltip
              content={`Your billing is managed by ${tenant?.parentTenant?.name}. Changes to be billing must be made from the ${tenant?.parentTenant?.name} team.`}
            >
              <Button variant="outline" disabled>
                Purchase extra credits
              </Button>
            </Tooltip>
          ) : (
            <Button variant="outline" onClick={purchaseCreditsModal.open}>
              Purchase extra credits
            </Button>
          )}
        </div>
      </div>
      <PurchaseCreditsModal
        isOpen={purchaseCreditsModalOpened}
        onClose={purchaseCreditsModal.close}
      />
    </Card>
  );
}

export default CreditsCard;
